import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Badge, Spinner, Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { 
  fetchAllergyActionPlans,
  selectPlans, 
  selectMeta, 
  selectLoading, 
  selectError
} from '../../../../store/allergyActionPlan/allergyActionPlanSlice';
import AllergyActionPlanListComp from '../../../../components/registrationPacket/AllergyActionPlanListComp';

const AllergyActionPlanList = () => {


  useEffect(() => {

  }, []);


  return (
    <Container>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center flex-wrap">
              <div className="header-title mb-2 mb-md-0 d-flex align-items-center">
                <i className="icon material-symbols-outlined me-2" style={{ verticalAlign: 'middle', fontSize: '22px' }}>health_and_safety</i>
                <h4 className="card-title mb-0">Individual Allergy/Anaphylaxis Action Plans</h4>
              </div>
              <Link to="/dashboard/allergy-action-plan/add">
                <Button variant="primary">
                  <i className="icon material-symbols-outlined me-1" style={{verticalAlign: 'middle'}}>add</i>
                  Create New Plan
                </Button>
              </Link>
            </Card.Header>
            <Card.Body>
              <AllergyActionPlanListComp />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AllergyActionPlanList;
